import { FilterDocument } from '@griply/types';

import { defaultInboxFilterDocument } from './constants/default-inbox-filter-document';

export const getInboxFilterDocument = (
  inboxFilters: FilterDocument | null | undefined,
): FilterDocument => {
  if (!inboxFilters) {
    return defaultInboxFilterDocument;
  }

  return {
    ...defaultInboxFilterDocument,
    ...inboxFilters,
    filters: {
      ...defaultInboxFilterDocument.filters,
      ...inboxFilters.filters,
    },
  };
};
